import { Observable, ReplaySubject } from 'rxjs';

/**
 * Primary class for all Poprs
 */
export abstract class Popr {
  private onOpen = new ReplaySubject<void>(1);
  private onClose = new ReplaySubject<void>(1);

  /**
   * open this {@link Popr}
   */
  open(): void {
    this.onOpen.next();
    this.onOpen.complete();
  }

  /**
   * close this {@link Popr}
   */
  close(): void {
    this.onClose.next();
    this.onClose.complete();
  }

  /**
   * Listen for the closing of the {@link Popr}
   */
  onClose$(): Observable<any> {
    return this.onClose.asObservable();
  }

  /**
   * Listen for the opening of the {@link Popr}
   */
  onOpen$(): Observable<any> {
    return this.onOpen.asObservable();
  }
}
